import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { ContainerStatusEnum } from '@gtpl/shared-models/common-models';

export class SaleOrderIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
    @ApiProperty()
    plantId?: number;
    @ApiProperty()
    itemId?: number;
    @ApiProperty()
    poNumber?: string;
    @ApiProperty()
    stockType?: string;
    @ApiProperty()
    poQuantity?: number;
    @ApiProperty()
    productId?: number;
    @ApiProperty()
    packStyleId?: number;
    @ApiProperty()
    reportedCases?:number
    @ApiProperty()
    productIdArray?:[]
    @ApiProperty()
    packStyleIdArray?:[]
    @ApiProperty()
    soakingOutProduct?:string
    @ApiProperty()
    loosePouches?:number
    @ApiProperty()
    noOfPouches?:number
}
export class SaleOrderNumberRequest {
    @ApiProperty()
    @IsNotEmpty()
    saleOrderNumber: string;
    @ApiProperty()
    plantId?: number;
}
export class SaleOrderItemsCasesRequest {
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId: number;
    @ApiProperty()
    @IsNotEmpty()
    reportingCases: number;
    @ApiProperty()
    reportedDate: Date;
}
export class SaleOrderItemRequest{
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId: number;
    @ApiProperty()
    @IsNotEmpty()
    plantId?: number;
    @IsNotEmpty()
    stockType?: string;
}
export class ItemsRequest{
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
    @ApiProperty()
    @IsNotEmpty()
    categoryId?: number;
    @ApiProperty()
    isPreparedMaterial?:string
}

export class StoreConsumptionItemsRequest{
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId: number;
    @ApiProperty()
    @IsNotEmpty()
    unitId?: number;
    @ApiProperty()
    isPreparedMaterial?:boolean

}
export class StoreConsumptionItemQtyReq{
    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    @IsNotEmpty()
    unitId?: number;
   
}

export class SolifeCycleCategoryReq{
    @ApiProperty()
    mainCategory:any

}